import { render, staticRenderFns } from "./Analysis_sales_tab.vue?vue&type=template&id=5b0a9001&scoped=true&"
import script from "./Analysis_sales_tab.vue?vue&type=script&lang=js&"
export * from "./Analysis_sales_tab.vue?vue&type=script&lang=js&"
import style0 from "./Analysis_sales_tab.vue?vue&type=style&index=0&id=5b0a9001&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a9001",
  null
  
)

export default component.exports